<template>
  <footer class="footer" :class="{ 'bg-secondary footer-border': isLoggedIn }">
    <div class="float-left footer-left">
      <p>Apix Messaging Oy</p>

      <p></p>
      <p>Keilaniementie 1, 02150 Espoo | Y-tunnus: 2332748-7</p>
    </div>
    <div class="float-right footer-right">
      <p>
        {{ $t("common.servicedesk") }}
      </p>
      <p>
        <a href="https://laskumappi.fi/#/terms" target="_blank">{{
          $t("common.tos")
        }}</a>
        | <a href="mailto:servicedesk@apixmessaging.com">servicedesk@apixmessaging.com</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  props: ["isLoggedIn"],
};
</script>

<style scoped>
.footer {
  position: absolute !important;
  bottom: 0;
  left: 0;
  height: 100px;
  width: 100%;
  color: #FFFFFF;
  text-align: left;
  padding: 5px;
}
.footer-border {
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: -1px 0 2px rgba(0, 0, 0, 0.15);
}
.footer-right {
  padding: 5px;
  text-align: right;
}
.footer-left {
  text-align: left;
  padding: 5px;
}
</style>